import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "./ui/dialog";
import { useState, useEffect } from "react";

export const PAUSE_REASONS = [
  { key: "banheiro", label: "Banheiro", emoji: "🚻", desc: "Pausa curta — sua posição na fila é mantida" },
  { key: "almoco", label: "Almoço", emoji: "🍽️", desc: "Sai das filas até voltar, sem perder o dia", highlight: true },
  { key: "procedimento", label: "Procedimento particular", emoji: "💅", desc: "Você fica pausada, posição mantida" },
  { key: "outro", label: "Outro", emoji: "✏️", desc: "Descreva na observação, se quiser" },
];

/**
 * Diálogo reutilizável para escolher motivo de pausa.
 * Motivo é OBRIGATÓRIO — não fecha sem escolher.
 */
export default function PauseReasonDialog({
  open,
  onOpenChange,
  onConfirm,
  title = "Motivo da pausa",
  description = "Escolha o motivo. É obrigatório.",
  submittingLabel = "Salvando…",
  testidPrefix = "pause",
}) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) {
      setNote("");
      setBusy(false);
    }
  }, [open]);

  const pick = async (reasonKey) => {
    setBusy(true);
    try {
      await onConfirm({ reason: reasonKey, note: note.trim() || null });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={`${testidPrefix}-dialog`}>
        <DialogHeader>
          <DialogTitle className="font-display">{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {PAUSE_REASONS.map((r) => (
            <button
              key={r.key}
              data-testid={`${testidPrefix}-${r.key}`}
              disabled={busy}
              onClick={() => pick(r.key)}
              className={`rounded-2xl border p-4 text-left transition-colors disabled:opacity-50 ${
                r.highlight
                  ? "border-pink-300 bg-pink-50 hover:border-black"
                  : "border-gray-200 bg-white hover:border-black hover:bg-pink-50/50"
              }`}
            >
              <div className="text-2xl">{r.emoji}</div>
              <div className="mt-1 font-medium">{r.label}</div>
              <div className="mt-1 text-[10px] leading-tight text-gray-500">{r.desc}</div>
            </button>
          ))}
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium uppercase tracking-wider text-gray-500">
            Observação (opcional)
          </label>
          <input
            data-testid={`${testidPrefix}-note`}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Ex.: volto em 40 minutos"
            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm outline-none focus:border-black"
          />
        </div>
        <DialogFooter>
          <button
            onClick={() => onOpenChange(false)}
            disabled={busy}
            className="rounded-full border border-gray-200 px-4 py-2 text-sm disabled:opacity-50"
          >
            {busy ? submittingLabel : "Voltar"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
